import * as React from 'react';

// tslint:disable:max-line-length
export const ElectricityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M14 6c0-3.3-2.7-6-6-6S2 2.7 2 6c0 2.2 1.2 4.2 3 5.2V13h6v-1.8c1.8-1 3-3 3-5.2zM7 16h2c1.1 0 2-.9 2-2H5c0 1.1.9 2 2 2z" />
    </g>
  </svg>
);
